import { Activity, Gauge, ShieldCheck, Timer } from 'lucide-react'
import { FadeIn } from '../components/ui/FadeIn'
import { GlassCard } from '../components/ui/GlassCard'
import { AnimatedNumber } from '../components/landing/AnimatedNumber'
import { useLanguage } from '../contexts/LanguageContext'

export function LiveStats() {
  const { t } = useLanguage()

  const stats = [
    {
      icon: ShieldCheck,
      value: 99.9,
      decimals: 1,
      suffix: '%',
      labelKey: 'stats.uptime',
      descKey: 'stats.uptime.desc',
    },
    {
      icon: Timer,
      value: 10,
      decimals: 0,
      suffix: 'ms',
      labelKey: 'stats.sos',
      descKey: 'stats.sos.desc',
    },
    {
      icon: Gauge,
      value: 5,
      decimals: 0,
      suffix: 'min',
      labelKey: 'stats.register',
      descKey: 'stats.register.desc',
    },
    {
      icon: Activity,
      value: 256,
      decimals: 0,
      suffix: '+',
      labelKey: 'stats.events',
      descKey: 'stats.events.desc',
    },
  ] as const

  return (
    <section id="descarga" className="relative">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
        <FadeIn>
          <div className="max-w-2xl">
            <div className="text-xs font-semibold tracking-[0.2em] text-nexus-blue/80">
              {t('stats.label')}
            </div>
            <h2 className="mt-3 text-balance text-3xl font-semibold tracking-tight sm:text-4xl">
              {t('stats.title')}
            </h2>
            <p className="mt-3 text-pretty text-white/70">
              {t('stats.description')}
            </p>
          </div>
        </FadeIn>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => {
            const Icon = s.icon
            return (
              <FadeIn key={s.labelKey} delay={0.05 * i} className="h-full">
                <GlassCard className="h-full">
                  <div className="flex items-start justify-between">
                    <div>
                      <div className="text-xs text-white/60">{t(s.labelKey)}</div>
                      <div className="mt-2 text-3xl font-semibold tracking-tight">
                        <AnimatedNumber value={s.value} decimals={s.decimals} />
                        <span className="text-white/65"> {s.suffix}</span>
                      </div>
                    </div>
                    <div className="grid size-11 place-items-center rounded-2xl bg-white/10 border border-white/10">
                      <Icon className="size-5 text-nexus-cyan" />
                    </div>
                  </div>
                  <div className="mt-3 text-sm text-white/70">{t(s.descKey)}</div>
                </GlassCard>
              </FadeIn>
              
            )
          })}
        </div>
      </div>
    </section>
  )
}


